export const MenuPaperStyled = {
    minWidth: "300px",
    maxWidth: "500px",
    width: "auto",
    maxHeight: "500px",
    height: "auto",
    borderRadius: '12px',
    marginTop: 1,

    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    overflow: 'hidden',
}

export const MenuListStyled = {
    display: 'contents',
    padding: '12px 0px',
    '& .MuiMenuItem-root': {
        alignSelf: 'start',
        minHeight: 'auto',
        height: 'auto',
        width: '100%',
        padding: '12px 16px',
        gap: 1,
        fontSize: '14px',
        fontWeight: 400,
    },
}

export const AvatarStyle = {
    height: "48px", 
    width: "48px",
}

export const TypTitle = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflowWrap: 'anywhere',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 1,
}

export const TypDescription = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflowWrap: 'anywhere',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
}
